import cn from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Stat } from "ui";

import { formatXof } from "../../financialFormat";
import { CategoryBreakdownProps } from "./CategoryBreakdown.types";
import CategoryRow from "./CategoryRow";

import styles from "./CategoryBreakdown.module.scss";

const CategoryBreakdown = ({
  level1,
  level2,
  variants,
  metric,
  totalValue,
  showComparison,
  shareLabel,
  productsLabel,
  renderProductExtra,
  renderProductBadge
}: CategoryBreakdownProps) => {
  const { t } = useTranslation();
  const [selectedLevel1, setSelectedLevel1] = useState<string | null>(null);

  const visibleLevel2 = selectedLevel1
    ? level2.filter((node) => node.parentCategoryId === selectedLevel1)
    : level2;

  return (
    <div>
      {level1.length > 0 && (
        <div className={styles.level1Row}>
          {level1.map((node) => {
            const isSelected = selectedLevel1 === node.categoryId;

            return (
              <button
                type="button"
                key={node.categoryId ?? "uncategorised"}
                className={cn(styles.level1Card, {
                  [styles["level1Card--selected"]]: isSelected
                })}
                onClick={() =>
                  setSelectedLevel1(isSelected ? null : node.categoryId)
                }
              >
                <Stat
                  size="sm"
                  title={node.categoryName ?? t("Uncategorised")}
                  amount={formatXof(node[metric])}
                />
              </button>
            );
          })}
        </div>
      )}

      <div className={styles.level2List}>
        {visibleLevel2.length === 0 && (
          <p className={styles.emptyMessage}>
            {t("There is no data for selected period")}
          </p>
        )}

        {visibleLevel2.map((node) => (
          <CategoryRow
            key={node.categoryId ?? "uncategorised"}
            node={node}
            variants={variants.filter(
              (variant) => variant.level2CategoryId === node.categoryId
            )}
            metric={metric}
            totalValue={totalValue}
            showComparison={showComparison}
            shareLabel={shareLabel}
            productsLabel={productsLabel}
            renderProductExtra={renderProductExtra}
            renderProductBadge={renderProductBadge}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryBreakdown;
